import { useTranslation } from "react-i18next"
import { Button, CheckOutlined } from "shared/ui"
import styled from "styled-components"

interface IPlanCardProps {
  id: string;
  title: string;
  price: React.ReactNode;
  description: React.ReactNode;
  storage: string;
  membersCount: string;
  membersText?: string;
  onActivate: (planId: string) => void;
  isProcessing: boolean;
  featuresList: string[];
  buttonText: string;
  storageText?: string;
}

export const PlanCard = ({
  id,
  title,
  price,
  description,
  storage,
  membersCount,
  onActivate,
  isProcessing,
  featuresList,
  buttonText,
  membersText,
  storageText,
}: IPlanCardProps) => {
  const { t } = useTranslation()
  
  return (
    <SPlanCard>
      <SPlanCardTitle>
        {title}
      </SPlanCardTitle>

      <SPlanCardPrice>
        {price}
      </SPlanCardPrice>

      <SPlanCardDescription>
        {description}
      </SPlanCardDescription>

      <SDivider />

      <SFeatureRow>
        <SFeatureIcon />

        {storageText || t('l_plans_planInfoOne', { size: storage, unit: '' })}
      </SFeatureRow>

      <SFeatureRow>
        <SFeatureIcon />
      
        {membersText || t('l_plans_planInfoTwo', { 0: membersCount })}
      </SFeatureRow>

      {featuresList.map((feature) => (
        <SFeatureRow key={feature}>
          <SFeatureIcon />

          {feature}
        </SFeatureRow>
      ))}
      
      <SActivateButton type="primary"
        size='large'
        onClick={() => onActivate(id)}
        loading={isProcessing}
      >
        {buttonText}
      </SActivateButton>
    </SPlanCard>
  )
}

const SPlanCard = styled.div`
  height: 550px;
  width: 325px;
  background-color: #F5F5F5;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  border: 2px solid transparent;

  &:hover {
    border-color: #8747DF;
  }
`

const SPlanCardTitle = styled.p`
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  color: #000000E0;
`

const SPlanCardPrice = styled.p`
  margin-top: 16px;
  font-size: 38px;
  line-height: 46px;
  font-weight: 600;
  color: #000000E0;

  span {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
  }
`

const SPlanCardDescription = styled.p`
  margin-top: 4px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  color: #00000073;
  max-width: 200px;
`

const SDivider = styled.div`
  margin: 24px 0;
  height: 1px;
  background-color: #D9D9D9;
`

const SFeatureRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #000000E0;
  max-width: 262px;

  & ~ & {
    margin-top: 16px;
  }
`

const SFeatureIcon = styled(CheckOutlined)`
  font-size: 20px;
  color: #000000E0;
`

const SActivateButton = styled(Button)`
  margin-top: auto;
  width: 100%;
`